import { usePrefixedSelector } from '../../internal/hooks/usePrefixedSelector';
/**
 * A hook to access the redux store's state. This hook takes a selector function as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter that allows you to customize the way the selected state is compared to determine whether the component needs to be re-rendered.
 *
 * If you do not want to have to specify the root state type for whenever you use this hook with an inline selector you can use the TypedUseSelectorHook interface to create a version of this hook that is properly typed for your root state.
 *
 * @param selector the selector function
 * @param equalityFn the function that will be used to determine equality
 * @returns the selected state
 * @example
 * import { useSelector } from 'react-redux'
 * import { RootState } from './store'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector((state: RootState) => state.counter)
 *   return <div>{counter}</div>
 * }
 */
export function useSelector(selector, equalityFn) {
    return usePrefixedSelector('app', selector, equalityFn);
}
//# sourceMappingURL=useSelector.js.map